const {
  environment: { host },
} = require("./environments/environment");

module.exports = {
  websiteName: {
    thalassa: "Thalassa",
    "select-together": "Select Together",
  },
  apiKey: "YBrYfc0S0fdrYTR0YYJKTYcgKIuQ2FwFPpOQLTel3ALVS4j7VsRxvon8cZAXvwFO",
  apiUrl: `${host}/api/web/content`,
  host: host,
  catalogueId: 1,
  googleApiKey: "AIzaSyD9FhsgpnYloyOo0jLPfHmMtlu2W8ZY114",
};
